
import PptxGenJS from 'pptxgenjs'
import html2canvas from 'html2canvas'

/*
 * Alignment:
 *  - 'center' - origin is the midpoint of two edges
 *  - 'after' - origin is the left/top edge
 *  - 'before' - origin is the right/bottom edge
 */

class PptxVector2 {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
  sum(x2, y2) {
    return new PptxVector2(this.x + x2, this.y + y2);
  }
}

class PptxRectangle {
  constructor(p1, p2) {
    this.p = [p1, p2];
  }
  FromScalars(originX, originY, offsetX, offsetY) {
    return new PptxRectangle(
      new PptxVector2(originX, originY),
      new PptxVector2(
        origin.x + offsetX,
        origin.y + offsetY
      ),
    );
  }
  getTopLeft() {
    return new PptxVector2(
      Math.min(this.p[0].x, this.p[1].x),
      Math.min(this.p[0].y, this.p[1].y)
    );
  }
  getBottomRight() {
    return new PptxVector2(
      Math.max(this.p[0].x, this.p[1].x),
      Math.max(this.p[0].y, this.p[1].y)
    );
  }
}

class PptxSlide {

  /**
   * @param doc {PptxGenerator}
   * @param slide {PptxGenJS.Slide}
   * @param size {PptxVector2}
   */
  constructor(doc, slide, size) {
    this.doc = doc;
    this.slide = slide;
    this.size = size;
  }

  getRatioPoint(x_ratio, y_ratio) {
    console.log("GetRatioPoint - size, ratio:", this.size, x_ratio);
    return new PptxVector2( this.size.x * x_ratio, this.size.y * y_ratio );
  }

  getSlide() {
    return this.slide;
  }

  addImageContained(dataUri, imageSize, pos, containSize) {
    const params = {
      data: dataUri,
      x: pos.x,
      y: pos.y,
      w: imageSize.x,
      h: imageSize.y,
      sizing: {
        type: 'contain',
        w: containSize.x,
        h: containSize.y
      }
    };
    console.log("Adding image", params, this, imageSize);
    this.slide.addImage(params);
  }

  static calculateAlignment(mode, origin, side) {
    switch (mode) {
      case 'top':
      case 'left':
      case 'before':
        return origin - side;
      case 'center':
      case 'middle':
        return origin - side / 2;
      case 'right':
      case 'bottom':
      case 'after':
        return origin;
      default:
        throw new Error("PptxSlide - failing to calculate alignment, must be one of 'before', 'center' or 'after'.");
    }
  }

  addImageProportional(dataUri, imageSize, origin, containSize, xAlignMode, yAlignMode) {

    const scaleScalar = 1 / Math.max(
      imageSize.x / containSize.x,
      imageSize.y / containSize.y,
      1,
    );

    const newSize = new PptxVector2(
      imageSize.x * scaleScalar,
      imageSize.y * scaleScalar,
    );

    const newOrigin = new PptxVector2(
      PptxSlide.calculateAlignment(xAlignMode, origin.x, newSize.x),
      PptxSlide.calculateAlignment(yAlignMode, origin.y, newSize.y)
    );

    const params = {
      data: dataUri,
      x: newOrigin.x,
      y: newOrigin.y,
      w: newSize.x,
      h: newSize.y,
      /*sizing: {
        type: 'contain',
        w: containSize.x,
        h: containSize.y
      }*/
    };
    console.log("Adding image (prop)", params, this, arguments, newOrigin, newSize);
    this.slide.addImage(params);
  }

}

class PptxGenerator {

  constructor(slideWidthInches, slideHeightInches) {
    this.size = new PptxVector2(parseFloat(slideWidthInches), parseFloat(slideHeightInches));
    this.size.ratio = slideHeightInches / slideHeightInches;

    if(!(this.size.w > 0.1 && this.size.w < 1000 && this.size.h > 0.1 && this.size.h < 1000)) {
      console.warn(`PptxGenerator: Size should be given in inches, 0.1-1000 (given: ${this.size.w}x${this.size.h})`);
    }
    if(this.size.ratio < 0.01 || this.size.ratio > 100) {
      console.warn(`PptxGenerator: Strange aspect ratio ${this.size.ratio} (${this.size.w}x${this.size.h})`);
    }

    this.doc = new PptxGenJS();
    this.doc.setLayout({ name:'Layout', width: slideWidthInches, height: slideHeightInches });
    this.slides = [];
  }

  getDoc() {
    return this.doc;
  }

  addNewSlide() {
    const s = new PptxSlide(this, this.doc.addNewSlide(), this.size);
    this.slides.push(s);
    return s;
  }

}

export class PptxDownload {

  static async RenderDomElement(el, dpi) {
    if(!dpi) dpi = 92 * window.devicePixelRatio || 92;
    console.log("Scale:", dpi, dpi/92);
    window.scroll(0, 0);
    console.log(el.offsetWidth);

    const parent = el.parentElement;
    const nextSibling = el.nextElementSibling;

    const rootEl = document.createElement("div");
    rootEl.classList.add('offscreen-canvas');
    rootEl.style.maxWidth = el.offsetWidth + "px";
    const wrapper = document.createElement("span");
    const styles = window.getComputedStyle(el);
    rootEl.style.textAlign = styles.getPropertyValue("text-align");
    wrapper.appendChild(el);
    rootEl.appendChild(wrapper);
    document.body.appendChild(rootEl);

    return new Promise(async (resolve, reject) => {
      setTimeout(() => {
        html2canvas(el, {
          scale: dpi/92,
          windowWidth: 1280,
          windowHeight: el.offsetHeight + 100,
          width: el.offsetWidth,
          height: el.offsetHeight,
          scrollX: 0,
          scrollY: 0,
          onclone: (cloned) => {
            console.log("cloned", cloned);
          },
          ignoreElements: (el) => {
            return el.classList.contains('ss-exclude');
          }, // todo: document
        }).then( canvas => resolve(canvas) )
          .catch( reject );
      }, 50); // add some delay to allow any click side effects to compute
    }).finally(() => {
      if(nextSibling) {
        parent.insertBefore(el, nextSibling);
      }else{
        parent.appendChild(el);
      }
      rootEl.parentElement.removeChild(rootEl);
    });
  }

  static OpenImageDataUrlInNewWindow(url) {
    var image = new Image();
    image.src = url;
    var w = window.open("");
    w.document.write(image.outerHTML);
  }

  static async GenerateSlideForDomElement(doc, el) {

    // todo: make parameters
    const alignmentX = 'right', alignmentY = 'bottom';
    let originXPct = '1', originYPct = '1';
    let containXPct = '98', containYPct = '98';
    let virtualDpiScalar = '0.75';
    const dpi = 300;

    virtualDpiScalar = parseFloat(virtualDpiScalar);

    originXPct = parseFloat(originXPct);
    originYPct = parseFloat(originYPct);
    if(originXPct < 0 || originXPct > 100 || originYPct < 0 || originXPct > 100) {
      throw new Error("Origin X/Y percentage must be between 0 and 100.");
    }

    containXPct = parseFloat(containXPct);
    containYPct = parseFloat(containYPct);
    if(containXPct < 0 || containXPct > 100 || containYPct < 0 || containXPct > 100) {
      throw new Error("Contain size X/Y percentage must be between 0 and 100.");
    }

    const ss = await PptxDownload.RenderDomElement(el, dpi * virtualDpiScalar);
    if(!ss) {
      throw new Error('PptxDownload::GenerateSlideForDomElement: Could not render the DOM element: ', el);
    }
    const dataUrl = ss.toDataURL();

    const slide = doc.addNewSlide();

    console.log("Adding new slide - doc, slide, el:", doc, slide, el);

    /*
    slide.addImageContained(dataUrl, // dataUrl
      new PptxVector2(ss.width / dpi, ss.height / dpi), // image size (natural)
      slide.getRatioPoint(0.03, 0.03), // origin
      slide.getRatioPoint(0.64, 0.94), // absolute maximum size
    );*/

    slide.addImageProportional(dataUrl, // dataUrl
      new PptxVector2(ss.width / dpi, ss.height / dpi), // image size (natural)
      slide.getRatioPoint(originXPct / 100, originYPct / 100), // origin
      slide.getRatioPoint(containXPct / 100, containYPct / 100), // absolute maximum size
      alignmentX,
      alignmentY
    );

    return slide;
  }

  static async GenerateFromDomElements(els) {
    const doc = new PptxGenerator( 13.333333333, 7.5 );
    const errors = [];
    let success = 0;

    for(let el of els) {
      try {
        await PptxDownload.GenerateSlideForDomElement(doc, el);
        success++;
      }catch (e) {
        errors.push(e);
      }
    }
    if(!success) {
      console.warn("PptxDownload::GenerateFromDomElements: Could not create any slides from elements!", els);
    }
    if(errors.length) {
      console.warn("PptxDownload::GenerateFromDomElements: encountered the following errors", errors)
    }
    return doc.getDoc();
  }

  static async GenerateFromDomElement(el) {
    return PptxDownload.GenerateFromDomElements([el]);
  }

}
